import { useEffect, useState } from 'react';

const DESIGN_WIDTH = 1920;
const MIN_SCALE = 0.75;
const MAX_SCALE = 1.25;

function getDesignScale() {
  return Math.min(MAX_SCALE, Math.max(MIN_SCALE, window.innerWidth / DESIGN_WIDTH));
}

/**
 * Synchronizes Ant Design's px-based runtime tokens with the 1920px design scale.
 * Tailwind and authored CSS are scaled through rem by PostCSS instead.
 */
export function useDesignScale() {
  const [scale, setScale] = useState(getDesignScale);

  useEffect(() => {
    let animationFrame = 0;

    const updateScale = () => {
      cancelAnimationFrame(animationFrame);
      animationFrame = requestAnimationFrame(() => setScale(getDesignScale()));
    };

    window.addEventListener('resize', updateScale);

    return () => {
      cancelAnimationFrame(animationFrame);
      window.removeEventListener('resize', updateScale);
    };
  }, []);

  return scale;
}
